import { getToken, setToken, removeToken } from '@/utils/Token';
import { passwordLogin, codeLogin, getuser, onekeylogin } from '@/api/user';
import { getSurplusApi } from '@/api/pay.js'

function TokenHandle(data) {
	const { token, refresh_token, refresh_token_expiresat, expiresat } = data;
	setToken({
		Token: token,
		Refresh_token: refresh_token,
		Refresh_token_expiresat: refresh_token_expiresat,
		Expiresat: expiresat,
	});
}

const state = {
	token: getToken(),
	userInfo: '',
	userSurplus: 0, // 余额
};
const mutations = {
	SET_TOKEN: (state, token) => {
		state.token = token;
	},
	SET_USERINFO: (state, userInfo) => {
		state.userInfo = userInfo;
	},
};

const actions = {
	// 获取余额
	async getSurplus ({ commit, state }) {
		const data = await getSurplusApi()
		state.userSurplus = data.data.data.surplus
	},
	// 一键登录
	oneKeyLogin ({ state }, userInfo) {
		const { phone, code } = userInfo;
		return new Promise((resolve, reject) => {
			onekeylogin({
				phone: phone,
				code: code,
				wechatKey: state.wechatkey,
			})
				.then((response) => {
					setToken({
						authorization: response.data.data.token,
						refresh_token: response.data.data.refresh_token,
						refresh_token_expiresat:
							response.data.data.refresh_token_expiresat,
						expiresat: response.data.data.expiresat,
					});
					resolve(response.data);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	// 密码登录
	passwordLogin (state, userInfo) {
		const { phone, password } = userInfo;
		return new Promise((resolve, reject) => {
			passwordLogin({ username: phone, password: password })
				.then((response) => {
					TokenHandle(response.data.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	// 验证码登录
	codeLogin (state, userInfo) {
		const { phone, code } = userInfo;
		return new Promise((resolve, reject) => {
			codeLogin({ phone: phone, code: code })
				.then((response) => {
					TokenHandle(response.data.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	// 获取用户信息
	getUserInfo ({ commit, state }) {
		return new Promise((resolve, reject) => {
			if (state.userInfo === '') {
				getuser()
					.then((response) => {
						if (response.data.headimg == '') {
							response.data.headimg = require('../../assets/1.jpg');
						}
						commit('SET_USERINFO', response.data.data);
						resolve(state.userInfo);
					})
					.catch((error) => {
						reject(error);
					});
			} else {
				resolve(state.userInfo);
			}
		});
	},
	// 退出登录
	loginOut () {
		removeToken();
		sessionStorage.clear();
	}
};

export default {
	namespaced: true,
	state,
	mutations,
	actions
};
